// Service worker registration (production only).
// Notifies the app via window event 'bk:sw-updated' when a new SW is ready.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Detect waiting SW already present (returning user with newer build).
        if (reg.waiting) {
          window.dispatchEvent(
            new CustomEvent("bk:sw-updated", { detail: reg })
          );
        }
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (
              sw.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              window.dispatchEvent(
                new CustomEvent("bk:sw-updated", { detail: reg })
              );
            }
          });
        });
      })
      .catch(() => {
        // Silent — SW is a progressive enhancement.
      });

    // Reload once the new SW takes control after user accepts the update.
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

export function applyServiceWorkerUpdate(registration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage("SKIP_WAITING");
  }
}
